var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8041)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8041",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8041)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#E31F37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.33325 10.6666H14.6667V-1.33337H-1.33325V10.6666Z",
    fill: "#083B9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6666 2.66673L5.7238 2.94287L5.99994 2.00006L5.7238 1.05725L6.6666 1.33339L7.60941 1.05725L7.33327 2.00006L7.60941 2.94287L6.6666 2.66673ZM6.6666 9.33339L5.7238 9.60954L5.99994 8.66673L5.7238 7.72392L6.6666 8.00006L7.60941 7.72392L7.33327 8.66673L7.60941 9.60954L6.6666 9.33339ZM3.05713 6.2762L3.99994 6.00006L4.94275 6.2762L4.6666 5.33339L4.94275 4.39058L3.99994 4.66673L3.05713 4.39058L3.33327 5.33339L3.05713 6.2762ZM9.99994 5.33339L9.05713 5.60954L9.33327 4.66673L9.05713 3.72392L9.99994 4.00006L10.9427 3.72392L10.6666 4.66673L10.9427 5.60954L9.99994 5.33339ZM8.6666 7.00006C8.6666 7.18415 8.51737 7.33339 8.33327 7.33339C8.14918 7.33339 7.99994 7.18415 7.99994 7.00006C7.99994 6.81597 8.14918 6.66673 8.33327 6.66673C8.51737 6.66673 8.6666 6.81597 8.6666 7.00006Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8041"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryWs);
export default __webpack_public_path__ + "static/media/Country=WS.45f00c54ec25f8eecb9ebde8ac089fb8.svg";
export { ForwardRef as ReactComponent };